import { useMutation } from 'react-query'
import callAPI from '../../API/callSecureAPI'
import endpoints from '../../API/endpoints'
import { useAuth0 } from '../../contexts/auth0-context'
import { useInvalidateActivitiesQuery } from './useInvalidateActivitiesQuery'

export type ExternalActivitySource = 'GSL' | 'Planisware'

type LinkActivityToExternalSourceVariables = {
    activityId: string
    roadmapId: string
    studyNumber: string
    source: ExternalActivitySource
}

export const useLinkActivityToExternalSourceMutation = () => {
    const { getTokenSilently } = useAuth0()
    const { invalidateActivitiesQuery } = useInvalidateActivitiesQuery()

    const linkActivityToExternalSource = async ({
        activityId,
        roadmapId,
        studyNumber,
        source,
    }: LinkActivityToExternalSourceVariables) => {
        const token = await getTokenSilently({ audience: 'https://atlas.aesara.com' })

        const { url, method } = endpoints.linkActivityToExternalSource

        const response = await callAPI(`${url}${activityId}/roadmap/${roadmapId}/link-external-source`, method, token, {
            studyNumber,
            source,
        })

        if (!response.success) {
            throw new Error(response.error ?? 'Failed to link activity to external source')
        }

        return response.data
    }

    return useMutation(linkActivityToExternalSource, {
        onSuccess: () => invalidateActivitiesQuery(),
    })
}
